import { PostReportsByDesignPreviewApiArg, serverApi } from '@/api/serverApi'
import { type PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '.'

export type ReportPreviewSlice = {
  reportUrl?: string | undefined | null
  generatingReport: boolean
}

const initialState: ReportPreviewSlice = {
  reportUrl: undefined,
  generatingReport: false,
}

export const generateReportAction = createAsyncThunk<void, { details: Omit<PostReportsByDesignPreviewApiArg['body'], 'design'> }, { state: RootState }>(
  'reportPreview/generateReport',
  async ({ details }, thunk) => {
    thunk.dispatch(reportPreviewSlice.actions.setReportUrl(null))

    const design = thunk.getState().activeDesign.design

    if (!design) {
      return thunk.abort()
    }

    const result = await thunk.dispatch(serverApi.endpoints.postReportsByDesignPreview.initiate({
      design: design!.id,
      body: {
        ...details,
      },
    })).unwrap()

    if ('error' in result) {
      return thunk.abort()
    }

    if (!result?.url) {
      return thunk.abort()
    }

    thunk.dispatch(reportPreviewSlice.actions.setReportUrl(result.url))
  },
)

export const reportPreviewSlice = createSlice({
  name: 'reportPreview',
  initialState,
  reducers: {
    setReportUrl: (state, action: PayloadAction<string | undefined | null>) => {
      state.reportUrl = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateReportAction.pending, (state) => {
        state.generatingReport = true
      })
      .addCase(generateReportAction.fulfilled, (state) => {
        state.generatingReport = false
      })
  },
})

export const { setReportUrl } = reportPreviewSlice.actions

export default reportPreviewSlice.reducer
